export default {
  forgot_password: {
    title: 'Đặt lại mật khẩu',
    required: '@:validation.required',
    incorrect_email_address: '@:validation.email_format',
    double_check_text: '@:login.double_check_text',
    forgot_password: 'Quên mật khẩu',
    password_reset_text: 'Nhập địa chỉ email của bạn. Bạn sẽ nhận được email xác nhận để đặt lại mật khẩu của mình.',
    submit: 'Gửi',
    mail_address: 'Điền địa chỉ email',
    input_label: '@:settings.user.email',
  },
}
